import { useContext, useState } from "react";
import CircularProgress from "@mui/material/CircularProgress";
import Context from "../Contex/Context";
import BaseUrl from "../BaseUrl";
import axios from "axios";
import Modal from "@mui/material/Modal";
import { Box, Fade } from "@mui/material";
import Backdrop from "@mui/material/Backdrop";
const style2 = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 500,
  bgcolor: "background.paper",
  borderRadius: "7px",
  boxShadow: 24,
  p: 2,
  zIndex: 200,
};
const Billing = () => {
  const userDetails = JSON.parse(localStorage.getItem("MailSenderuserDetails"));
  const [loader, setLoader] = useState(false);
  const billingArray = ["BILLING PERIOD", "PLAN", "PRICE", "STATUS", "Action"];
  const { currentPlan,setUserPlanInformation, setCurrentPlan, } = useContext(Context);
  const [open, setOpen] = useState(false);
  function convertUnixTimestampToDateFormat(unixTimestamp) {
    const dateObject = new Date(unixTimestamp);
    const options = { month: "short", day: "numeric", year: "numeric" };
    const formattedDate = dateObject.toLocaleDateString("en-US", options);
    return formattedDate;
  }

function cancelSubscription(){
  let config = {
    method: "post",
    maxBodyLength: Infinity,
    url: `${BaseUrl.baseurl}/email-marketing/user/user-cancel-subscription/${
      userDetails && userDetails.details._id
    }`,
    headers: {
      Authorization: `Bearear ${userDetails && userDetails.token}`,
    },
  };

  axios
    .request(config)
    .then((response) => {
      getUserCurrentPlan()
    })
    .catch((error) => {
      console.log(error);
    });
}
function getUserCurrentPlan() {
  axios
    .get(
      `${BaseUrl.baseurl}/email-marketing/user/get-user-current-plan/${
        userDetails && userDetails.details._id
      }`,
      {
        headers: {
          Authorization: `Bearear ${userDetails && userDetails.token}`,
        },
      }
    )
    .then((response) => {
      if (response.data.status) {
        setCurrentPlan(response.data);
        setUserPlanInformation(response.data.user.Api_Key);
      } else {
        if (response.data.tokenExpire) {
          localStorage.removeItem("MailSenderuserDetails");
          window.location.reload();
        }
      }
    })
    .catch((err) => console.log("Error"));
}
  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        gap: "20px",
        backgroundColor: "#fff",
        padding: "16px",
        // boxShadow: "rgba(0, 0, 0, 0.15) 1.70px 1.70px 2.6px",
        borderRadius: "4px",
      }}
    >
      {loader ? (
        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            height: "60vh",
          }}
        >
          <CircularProgress
            size={40}
            style={{
              color: "#1C485F",
            }}
          />
        </div>
      ) : (
        <>
          <div>
            <h1
              style={{
                lineHeight: "20px",
                color: "#393939",
                fontFamily: "Source Sans 3",
                fontSize: "18px",
                fontStyle: "normal",
                fontWeight: 700,
              }}
            >
              Current billing period
            </h1>

            <div>
              <p
                style={{
                  color: "#393939",
                  margin: "16px 0px",
                  fontFamily: "Source Sans 3",
                  fontStyle: "normal",
                  fontSize: "18px",
                  fontWeight: 700,
                }}
              >
                {currentPlan.plan?.SubscriptionDetails?.Name}
              </p>
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  gap: "10px",
                  alignItems: "flex-start",
                }}
              >
                <button
                  style={{
                    backgroundColor: "#E9F7E9",
                    color: "#53D86A",
                    fontSize: "12px",
                    fontFamily: "Source Sans 3",
                    fontStyle: "normal",
                    borderRadius: "20px",
                    padding: "5px 10px",
                    outline: "none",
                  }}
                >
                  Purchased on:{" "}
                  {convertUnixTimestampToDateFormat(
                    currentPlan.plan?.StartedDate
                  )}
                </button>
                <button
                  style={{
                    backgroundColor: "#FFEDE8",
                    color: "#FF3434",
                    fontSize: "12px",
                    fontFamily: "Source Sans 3",
                    fontStyle: "normal",
                    borderRadius: "20px",
                    padding: "5px 10px",
                    outline: "none",
                  }}
                >
                  Expires on:{" "}
                  {convertUnixTimestampToDateFormat(
                    currentPlan.plan?.ExpiryDate
                  )}
                </button>
              </div>
            </div>
          </div>

          <div className="billingboxtabheaf">
            {billingArray.map((val) => (
              <div className="insidebillingbox">{val}</div>
            ))}
          </div>
          {console.log("current plan",currentPlan)}
          {currentPlan?.subscriptionList?.length !== 0 ? (
            <>
              {currentPlan?.subscriptionList?.map((val, index) => {
                return (
                  <div className="billingrowsofdata">
                    <div className="valueinsidethecontent">
                      {convertUnixTimestampToDateFormat(val.StartedDate)} -{" "}
                      {convertUnixTimestampToDateFormat(val.ExpiryDate)}
                    </div>
                    <div className="valueinsidethecontent">
                      {val.SubscriptionDetails.Name}
                    </div>
                    <div
                      className="valueinsidethecontent"
                      style={{ textAlign: "center" }}
                    >
                      {val.SubscriptionDetails.Price === 0
                        ? 0
                        : `${val.SubscriptionDetails.Price} ${val.SubscriptionDetails.PriceUnit}`}
                    </div>
                    <div
                      className="valueinsidethecontent"
                      style={{ textAlign: "center" }}
                    >
                      {val.Status ? "Active" : "InActive"}
                    </div>
                    <div
                      className="valueinsidethecontent"
                      style={{ textAlign: "center" }}
                    >
                      {val.SubscriptionDetails.Name!=="Free"?(
                                          <div
                                          onClick={()=>{
                                            setOpen(true);
                                          
                                          }}
                                            style={{
                                              textDecoration: "none",
                                              padding: "8px 16px",
                                              backgroundColor: "#D1DFE9",
                                              color: "#1C485F",
                                              fontFamily: "Source Sans 3",
                                              fontStyle: "normal",
                                              fontSize: "12px",
                                              fontWeight: 400,
                                              outline: "none",
                                              borderRadius: "4px",
                                              cursor: "pointer",
                                            }}
                                          >
                                            Cancel Subscription
                                          </div>
                      ):<div>-----</div>}
                     
                    </div>
                  </div>
                );
              })}
            </>
          ) : (
            <div className="billingtbodybox">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="240"
                height="240"
                viewBox="0 0 240 240"
                fill="none"
              >
                <path d="M240 183.553H0V183.673H240V183.553Z" fill="#EBEBEB" />
                <path
                  d="M215.952 191.275H200.055V191.395H215.952V191.275Z"
                  fill="#EBEBEB"
                />
                <path
                  d="M158.986 192.582H154.814V192.702H158.986V192.582Z"
                  fill="#EBEBEB"
                />
                <path
                  d="M199.574 186.82H190.363V186.94H199.574V186.82Z"
                  fill="#EBEBEB"
                />
                <path
                  d="M45.9128 187.627H25.1816V187.747H45.9128V187.627Z"
                  fill="#EBEBEB"
                />
                <path
                  d="M53.2279 187.627H50.1895V187.747H53.2279V187.627Z"
                  fill="#EBEBEB"
                />
                <path
                  d="M108.072 189.652H63.1055V189.772H108.072V189.652Z"
                  fill="#EBEBEB"
                />
                <path
                  d="M113.759 162.144H21.0758C20.3498 162.143 19.6539 161.854 19.1409 161.34C18.6279 160.826 18.3398 160.13 18.3398 159.404V29.1172C18.3462 28.3953 18.6371 27.705 19.1493 27.1963C19.6616 26.6877 20.3539 26.4016 21.0758 26.4004H113.759C114.486 26.4004 115.183 26.6892 115.697 27.2032C116.211 27.7172 116.5 28.4143 116.5 29.1412V159.404C116.5 160.13 116.211 160.828 115.697 161.342C115.183 161.856 114.486 162.144 113.759 162.144ZM21.0758 26.4964C20.3816 26.4977 19.7162 26.7743 19.2258 27.2657C18.7353 27.7571 18.4598 28.4229 18.4598 29.1172V159.404C18.4598 160.098 18.7353 160.764 19.2258 161.255C19.7162 161.746 20.3816 162.023 21.0758 162.024H113.759C114.454 162.023 115.12 161.747 115.611 161.255C116.102 160.764 116.379 160.098 116.38 159.404V29.1172C116.379 28.4225 116.102 27.7566 115.611 27.2654C115.12 26.7742 114.454 26.4977 113.759 26.4964H21.0758Z"
                  fill="#EBEBEB"
                />
                <path
                  d="M217.589 162.144H124.901C124.174 162.143 123.478 161.854 122.964 161.34C122.451 160.827 122.161 160.13 122.16 159.404V29.1172C122.168 28.3948 122.46 27.7046 122.973 27.196C123.486 26.6875 124.179 26.4016 124.901 26.4004H217.589C218.31 26.4029 219.001 26.6895 219.512 27.198C220.024 27.7066 220.314 28.3961 220.32 29.1172V159.404C220.32 160.129 220.033 160.825 219.521 161.338C219.009 161.852 218.314 162.142 217.589 162.144ZM124.901 26.4964C124.206 26.4977 123.54 26.7742 123.049 27.2654C122.558 27.7566 122.281 28.4225 122.28 29.1172V159.404C122.281 160.098 122.558 160.764 123.049 161.255C123.54 161.747 124.206 162.023 124.901 162.024H217.589C218.284 162.023 218.95 161.747 219.441 161.255C219.932 160.764 220.208 160.098 220.21 159.404V29.1172C220.208 28.4225 219.932 27.7566 219.441 27.2654C218.95 26.7742 218.284 26.4977 217.589 26.4964H124.901Z"
                  fill="#EBEBEB"
                />
                <path
                  d="M139.051 83.5488L205.186 83.5488V40.2384L139.051 40.2384V83.5488Z"
                  fill="#E6E6E6"
                />
                <path
                  d="M137.031 83.5488L204.24 83.5488V40.2384L137.031 40.2384V83.5488Z"
                  fill="#F0F0F0"
                />
                <path
                  d="M139.051 92.0449L205.186 92.0449V83.5441L139.051 83.5441V92.0449Z"
                  fill="#E6E6E6"
                />
                <path
                  d="M133.675 92.0449L200.885 92.0449V83.5441L133.675 83.5441V92.0449Z"
                  fill="#F0F0F0"
                />
                <path
                  d="M201.418 80.7272V43.0664L139.858 43.0664V80.7272H201.418Z"
                  fill="#FAFAFA"
                />
                <path
                  d="M187.535 80.7224L179.673 43.0664H167.404L175.267 80.7224H187.535Z"
                  fill="white"
                />
                <path
                  d="M200.112 77.9144C200.139 77.9144 200.165 77.909 200.19 77.8986C200.215 77.8882 200.237 77.8729 200.256 77.8536C200.275 77.8344 200.29 77.8116 200.299 77.7866C200.309 77.7616 200.314 77.7349 200.313 77.708V44.9048C200.313 44.8513 200.292 44.8 200.254 44.7622C200.217 44.7244 200.165 44.7032 200.112 44.7032C200.085 44.7025 200.059 44.7073 200.034 44.7172C200.009 44.7271 199.987 44.7419 199.968 44.7608C199.949 44.7796 199.934 44.8021 199.924 44.8269C199.914 44.8516 199.91 44.8781 199.91 44.9048V77.708C199.91 77.7349 199.914 77.7616 199.924 77.7866C199.934 77.8116 199.949 77.8344 199.968 77.8536C199.986 77.8729 200.009 77.8882 200.034 77.8986C200.058 77.909 200.085 77.9144 200.112 77.9144Z"
                  fill="#F0F0F0"
                />
                <path
                  d="M172.632 80.7224L164.77 43.0664H159.984L167.852 80.7224H172.632Z"
                  fill="white"
                />
                <path
                  d="M140.217 80.7272V43.0664H139.857V80.7272H140.217Z"
                  fill="#E6E6E6"
                />
                <path
                  opacity="0.6"
                  d="M136.367 47.3234H202.502L202.761 44.1602H136.626L136.367 47.3234Z"
                  fill="#EBEBEB"
                />
                <path
                  opacity="0.6"
                  d="M136.367 52.508H202.502L202.761 49.3496H136.626L136.367 52.508Z"
                  fill="#EBEBEB"
                />
                <path
                  opacity="0.6"
                  d="M136.367 57.6916H202.502L202.761 54.5332H136.626L136.367 57.6916Z"
                  fill="#EBEBEB"
                />
                <path
                  opacity="0.6"
                  d="M136.367 62.88H202.502L202.761 59.7168H136.626L136.367 62.88Z"
                  fill="#EBEBEB"
                />
                <path
                  opacity="0.6"
                  d="M136.367 68.0636H202.502L202.761 64.9004H136.626L136.367 68.0636Z"
                  fill="#EBEBEB"
                />
                <path
                  opacity="0.6"
                  d="M136.367 73.2491H202.502L202.761 70.0859H136.626L136.367 73.2491Z"
                  fill="#EBEBEB"
                />
                <path
                  d="M195.691 152.055H181.824V154.791H195.691V152.055Z"
                  fill="#E6E6E6"
                />
                <path
                  d="M155.668 183.553H158.227V120.639H155.668V183.553Z"
                  fill="#E6E6E6"
                />
                <path
                  d="M146.798 154.791H181.818V152.055H146.798V154.791Z"
                  fill="#F5F5F5"
                />
                <path
                  d="M195.691 167.016H181.824V169.752H195.691V167.016Z"
                  fill="#E6E6E6"
                />
                <path
                  d="M146.798 169.748H181.818V167.012H146.798V169.748Z"
                  fill="#F5F5F5"
                />
                <path
                  d="M195.691 122.137H181.824V124.873H195.691V122.137Z"
                  fill="#E6E6E6"
                />
                <path
                  d="M146.798 124.867H181.818V122.131H146.798V124.867Z"
                  fill="#F5F5F5"
                />
                <path
                  d="M195.691 137.094H181.824V139.83H195.691V137.094Z"
                  fill="#E6E6E6"
                />
                <path
                  d="M146.798 139.83H181.818V137.094H146.798V139.83Z"
                  fill="#F5F5F5"
                />
                <path
                  d="M190.694 183.553H193.252V120.639H190.694V183.553Z"
                  fill="#E6E6E6"
                />
                <path
                  d="M179.26 183.553H181.818V120.639H179.26V183.553Z"
                  fill="#F5F5F5"
                />
                <path
                  d="M146.799 183.553H149.357V120.639H146.799V183.553Z"
                  fill="#F5F5F5"
                />
                <path
                  d="M31.3817 183.553H57.5801L57.5801 132.726H31.3817L31.3817 183.553Z"
                  fill="#E6E6E6"
                />
                <path
                  d="M38.3753 183.553H31.377V176.535H45.7098L38.3753 183.553Z"
                  fill="#FAFAFA"
                />
                <path
                  d="M102.805 183.553H129.004V132.726H102.805V183.553Z"
                  fill="#E6E6E6"
                />
                <path
                  d="M31.3816 181.133H108.916V132.72H31.3816V181.133Z"
                  fill="#FAFAFA"
                />
                <path
                  d="M101.918 183.553H108.912V176.535H94.584L101.918 183.553Z"
                  fill="#FAFAFA"
                />
                <path
                  d="M36.8067 162.879H103.488V150.764H36.8067V162.879Z"
                  fill="#F0F0F0"
                />
                <path
                  d="M36.8067 177.582H103.488V165.467H36.8067V177.582Z"
                  fill="#F0F0F0"
                />
                <path
                  d="M90.8162 152.061H49.4834C48.9003 152.061 48.3411 151.829 47.9289 151.417C47.5166 151.004 47.285 150.445 47.285 149.862V149.713H93.0098V149.862C93.0098 150.444 92.7788 151.003 92.3676 151.415C91.9563 151.827 91.3984 152.059 90.8162 152.061Z"
                  fill="#FAFAFA"
                />
                <path
                  d="M36.8067 148.172H103.488V136.057H36.8067V148.172Z"
                  fill="#F0F0F0"
                />
                <path
                  d="M90.8162 137.352H49.4834C48.9003 137.352 48.3411 137.12 47.9289 136.708C47.5166 136.295 47.285 135.736 47.285 135.153V135.004H93.0098V135.153C93.0098 135.735 92.7788 136.294 92.3676 136.706C91.9563 137.118 91.3984 137.35 90.8162 137.352Z"
                  fill="#FAFAFA"
                />
                <path
                  d="M90.8162 166.768H49.4834C48.9003 166.768 48.3411 166.536 47.9289 166.124C47.5166 165.711 47.285 165.152 47.285 164.569V164.42H93.0098V164.569C93.0098 165.151 92.7788 165.71 92.3676 166.122C91.9563 166.534 91.3984 166.766 90.8162 166.768Z"
                  fill="#FAFAFA"
                />
                <path
                  d="M35.5531 83.5488L101.688 83.5488V40.2384L35.5531 40.2384V83.5488Z"
                  fill="#E6E6E6"
                />
                <path
                  d="M33.5384 83.5488L100.748 83.5488V40.2384L33.5384 40.2384V83.5488Z"
                  fill="#F0F0F0"
                />
                <path
                  d="M35.5531 92.0449L101.688 92.0449V83.5441L35.5531 83.5441V92.0449Z"
                  fill="#E6E6E6"
                />
                <path
                  d="M30.1732 92.0449L97.3828 92.0449V83.5441L30.1732 83.5441V92.0449Z"
                  fill="#F0F0F0"
                />
                <path
                  d="M97.9199 80.7272V43.0664L36.3599 43.0664V80.7272H97.9199Z"
                  fill="#FAFAFA"
                />
                <path
                  d="M84.0375 80.7224L76.175 43.0664H63.9062L71.7687 80.7224H84.0375Z"
                  fill="white"
                />
                <path
                  d="M96.6099 77.9144C96.6367 77.9144 96.6634 77.909 96.6881 77.8986C96.7129 77.8882 96.7353 77.8729 96.7541 77.8536C96.7729 77.8344 96.7877 77.8116 96.7975 77.7866C96.8074 77.7616 96.8121 77.7349 96.8115 77.708V44.9048C96.8121 44.8781 96.8074 44.8516 96.7975 44.8269C96.7876 44.8021 96.7727 44.7796 96.7539 44.7608C96.735 44.7419 96.7125 44.7271 96.6878 44.7172C96.663 44.7073 96.6365 44.7025 96.6099 44.7032C96.5564 44.7032 96.5051 44.7244 96.4673 44.7622C96.4295 44.8 96.4083 44.8513 96.4083 44.9048V77.708C96.4076 77.7349 96.4124 77.7616 96.4222 77.7866C96.432 77.8116 96.4468 77.8344 96.4656 77.8536C96.4844 77.8729 96.5068 77.8882 96.5316 77.8986C96.5564 77.909 96.583 77.9144 96.6099 77.9144Z"
                  fill="#F0F0F0"
                />
                <path
                  d="M69.1343 80.7224L61.2719 43.0664H56.4863L64.3487 80.7224H69.1343Z"
                  fill="white"
                />
                <path
                  d="M36.7207 80.7272V43.0664H36.3607V80.7272H36.7207Z"
                  fill="#E6E6E6"
                />
                <path
                  opacity="0.6"
                  d="M32.8652 47.3234H98.9996L99.2588 44.1602H33.1244L32.8652 47.3234Z"
                  fill="#EBEBEB"
                />
                <path
                  opacity="0.6"
                  d="M32.8652 49.1085H98.9996L99.2588 45.9453H33.1244L32.8652 49.1085Z"
                  fill="#EBEBEB"
                />
                <path
                  opacity="0.6"
                  d="M32.8652 50.8908H98.9996L99.2588 47.7324H33.1244L32.8652 50.8908Z"
                  fill="#EBEBEB"
                />
                <path
                  opacity="0.6"
                  d="M32.8652 52.6749H98.9996L99.2588 49.5117H33.1244L32.8652 52.6749Z"
                  fill="#EBEBEB"
                />
                <path
                  opacity="0.6"
                  d="M32.8652 54.4572H98.9996L99.2588 51.2988H33.1244L32.8652 54.4572Z"
                  fill="#EBEBEB"
                />
                <path
                  opacity="0.6"
                  d="M32.8652 56.2413H98.9996L99.2588 53.0781H33.1244L32.8652 56.2413Z"
                  fill="#EBEBEB"
                />
                <path
                  d="M46.0902 131.17H48.375V105.687H46.0902V131.17Z"
                  fill="#F5F5F5"
                />
                <path
                  d="M46.3774 131.156H47.0254V105.673H46.3774V131.156Z"
                  fill="#FAFAFA"
                />
                <path
                  d="M47.2944 131.156H47.5488V105.673H47.2944V131.156Z"
                  fill="#FAFAFA"
                />
                <path
                  d="M55.6953 132.725H38.7801C38.7801 132.159 39.0047 131.617 39.4043 131.218C39.804 130.818 40.3461 130.593 40.9113 130.593H53.5593C54.1245 130.593 54.6666 130.818 55.0663 131.218C55.466 131.617 55.6905 132.159 55.6905 132.725H55.6953Z"
                  fill="#F0F0F0"
                />
                <path
                  d="M43.1233 121.507C43.2974 121.506 43.4639 121.436 43.5869 121.313C43.71 121.19 43.7797 121.023 43.7809 120.849V104.16C43.7809 103.985 43.7117 103.818 43.5883 103.695C43.465 103.571 43.2977 103.502 43.1233 103.502C43.0366 103.501 42.9505 103.518 42.8702 103.551C42.7899 103.583 42.7168 103.632 42.6552 103.693C42.5937 103.754 42.5448 103.827 42.5114 103.907C42.4781 103.987 42.4609 104.073 42.4609 104.16V120.868C42.4672 121.04 42.5397 121.202 42.6632 121.321C42.7868 121.44 42.9517 121.507 43.1233 121.507Z"
                  fill="#F0F0F0"
                />
                <path
                  d="M36.9941 111.743H57.4661L55.1093 97.4395H39.3509L36.9941 111.743Z"
                  fill="#E0E0E0"
                />
                <path
                  d="M120.001 205.229C171.4 205.229 213.068 202.796 213.068 199.795C213.068 196.794 171.4 194.361 120.001 194.361C68.6012 194.361 26.9336 196.794 26.9336 199.795C26.9336 202.796 68.6012 205.229 120.001 205.229Z"
                  fill="#F5F5F5"
                />
                <path
                  d="M49.9768 97.1335L49.498 97.168L50.1357 106.02L50.6145 105.986L49.9768 97.1335Z"
                  fill="#393939"
                />
                <path
                  d="M50.9397 110.555L50.4609 110.59L50.701 113.922L51.1797 113.888L50.9397 110.555Z"
                  fill="#393939"
                />
                <path
                  d="M162.101 151.277H59.3044C58.1601 151.257 57.064 150.813 56.2273 150.032C55.3906 149.251 54.8726 148.188 54.7732 147.048L49.7236 76.9059C49.6766 76.365 49.7435 75.8202 49.9198 75.3067C50.0962 74.7931 50.3782 74.3222 50.7477 73.9243C51.1171 73.5264 51.5658 73.2102 52.0648 72.9963C52.5639 72.7823 53.1022 72.6752 53.6452 72.6819H156.442C157.585 72.7024 158.681 73.1452 159.518 73.925C160.354 74.7049 160.873 75.7667 160.973 76.9059L166.023 147.048C166.07 147.59 166.003 148.135 165.826 148.648C165.65 149.162 165.368 149.633 164.999 150.032C164.629 150.43 164.181 150.746 163.682 150.961C163.183 151.175 162.644 151.283 162.101 151.277Z"
                  fill="#393939"
                />
                <path
                  d="M162.494 151.277H59.6969C58.5527 151.257 57.4565 150.813 56.6198 150.032C55.7832 149.251 55.2652 148.188 55.1657 147.048L50.1161 76.9059C50.0692 76.365 50.136 75.8202 50.3124 75.3067C50.4888 74.7931 50.7708 74.3222 51.1402 73.9243C51.5097 73.5264 51.9584 73.2102 52.4574 72.9963C52.9565 72.7823 53.4948 72.6752 54.0377 72.6819H156.835C157.978 72.7024 159.074 73.1452 159.91 73.925C160.747 74.7049 161.265 75.7667 161.366 76.9059L166.415 147.048C166.463 147.59 166.397 148.135 166.221 148.649C166.045 149.163 165.763 149.635 165.393 150.033C165.024 150.432 164.575 150.748 164.075 150.962C163.576 151.177 163.037 151.284 162.494 151.277Z"
                  fill="#393939"
                />
                <path
                  opacity="0.5"
                  d="M162.494 151.277H59.6969C58.5527 151.257 57.4565 150.813 56.6198 150.032C55.7832 149.251 55.2652 148.188 55.1657 147.048L50.1161 76.9059C50.0692 76.365 50.136 75.8202 50.3124 75.3067C50.4888 74.7931 50.7708 74.3222 51.1402 73.9243C51.5097 73.5264 51.9584 73.2102 52.4574 72.9963C52.9565 72.7823 53.4948 72.6752 54.0377 72.6819H156.835C157.978 72.7024 159.074 73.1452 159.91 73.925C160.747 74.7049 161.265 75.7667 161.366 76.9059L166.415 147.048C166.463 147.59 166.397 148.135 166.221 148.649C166.045 149.163 165.763 149.635 165.393 150.033C165.024 150.432 164.575 150.748 164.075 150.962C163.576 151.177 163.037 151.284 162.494 151.277Z"
                  fill="white"
                />
                <path
                  d="M156.988 74.7949H54.1913H53.8457C51.2201 75.0109 51.7577 79.0093 54.4073 79.0093H157.377C160.031 79.0093 159.993 75.0109 157.334 74.7949H156.988Z"
                  fill="#393939"
                />
                <path
                  d="M56.8699 76.9054C56.88 77.0291 56.864 77.1536 56.823 77.2708C56.782 77.388 56.7169 77.4953 56.6318 77.5858C56.5468 77.6762 56.4437 77.7479 56.3293 77.796C56.2149 77.8442 56.0916 77.8678 55.9675 77.8654C55.7066 77.8617 55.4563 77.7616 55.2648 77.5844C55.0734 77.4071 54.9544 77.1652 54.9307 76.9054C54.9206 76.7821 54.9365 76.658 54.9772 76.5411C55.0179 76.4243 55.0826 76.3172 55.1671 76.2268C55.2516 76.1364 55.3541 76.0647 55.4679 76.0163C55.5818 75.9678 55.7045 75.9437 55.8283 75.9454C56.09 75.9479 56.3414 76.0475 56.5339 76.2248C56.7264 76.4022 56.8461 76.6448 56.8699 76.9054Z"
                  fill="#FAFAFA"
                />
                <path
                  d="M60.1687 76.9054C60.1788 77.0291 60.1628 77.1536 60.1218 77.2708C60.0808 77.388 60.0157 77.4953 59.9307 77.5858C59.8456 77.6762 59.7426 77.7479 59.6281 77.796C59.5137 77.8442 59.3904 77.8678 59.2663 77.8654C59.0054 77.8617 58.7551 77.7616 58.5637 77.5844C58.3722 77.4071 58.2532 77.1652 58.2295 76.9054C58.2194 76.7821 58.2353 76.658 58.276 76.5411C58.3167 76.4243 58.3814 76.3172 58.4659 76.2268C58.5504 76.1364 58.6529 76.0647 58.7668 76.0163C58.8806 75.9678 59.0034 75.9437 59.1271 75.9454C59.3888 75.9479 59.6403 76.0475 59.8327 76.2248C60.0252 76.4022 60.1449 76.6448 60.1687 76.9054Z"
                  fill="#FAFAFA"
                />
                <path
                  d="M63.4612 76.9055C63.4713 77.0288 63.4554 77.1529 63.4147 77.2698C63.374 77.3866 63.3093 77.4937 63.2248 77.5841C63.1403 77.6744 63.0378 77.7462 62.9239 77.7946C62.8101 77.8431 62.6873 77.8672 62.5636 77.8655C62.3024 77.8629 62.0515 77.7631 61.8599 77.5857C61.6682 77.4082 61.5494 77.1657 61.5268 76.9055C61.516 76.782 61.5313 76.6576 61.5717 76.5404C61.6122 76.4232 61.6768 76.3159 61.7615 76.2253C61.8462 76.1348 61.949 76.063 62.0632 76.0148C62.1774 75.9666 62.3005 75.943 62.4244 75.9455C62.6853 75.9492 62.9356 76.0493 63.127 76.2265C63.3185 76.4038 63.4375 76.6457 63.4612 76.9055Z"
                  fill="#FAFAFA"
                />
                <path
                  d="M159.768 144.279H61.4403C61.0249 144.272 60.6269 144.111 60.3236 143.827C60.0202 143.543 59.8332 143.157 59.7987 142.743L55.6467 85.0612C55.6282 84.8633 55.652 84.6637 55.7166 84.4756C55.7812 84.2876 55.885 84.1155 56.0212 83.9707C56.1574 83.8259 56.3228 83.7117 56.5065 83.6357C56.6902 83.5597 56.888 83.5237 57.0867 83.53H155.439C155.854 83.5357 156.252 83.6957 156.555 83.9787C156.859 84.2618 157.046 84.6477 157.08 85.0612L161.237 142.743C161.255 142.943 161.23 143.145 161.163 143.335C161.097 143.525 160.991 143.699 160.851 143.844C160.712 143.99 160.544 144.104 160.357 144.179C160.17 144.254 159.969 144.288 159.768 144.279Z"
                  fill="white"
                />
                <path
                  d="M118.335 122.304L116.732 100.071L111.884 97.1523H98.5352L100.35 122.304H118.335Z"
                  fill="white"
                />
                <path
                  d="M118.334 122.536H100.348C100.289 122.537 100.231 122.515 100.187 122.475C100.143 122.435 100.117 122.379 100.113 122.32L98.3033 97.1676C98.301 97.136 98.3054 97.1043 98.3161 97.0745C98.3269 97.0448 98.3438 97.0176 98.3657 96.9948C98.3869 96.9711 98.4128 96.952 98.4417 96.9388C98.4706 96.9256 98.5019 96.9185 98.5337 96.918H111.883C111.925 96.9194 111.966 96.9309 112.003 96.9516L116.851 99.87C116.883 99.8887 116.911 99.9151 116.931 99.9468C116.951 99.9786 116.963 100.015 116.966 100.052L118.559 122.286C118.563 122.318 118.559 122.351 118.548 122.382C118.537 122.412 118.52 122.44 118.497 122.464C118.476 122.486 118.451 122.504 118.423 122.516C118.395 122.529 118.364 122.535 118.334 122.536ZM100.574 122.056H118.079L116.505 100.192L111.839 97.3836H98.7833L100.574 122.056Z"
                  fill="#393939"
                />
                <path
                  d="M116.731 100.071L111.883 97.1523L113.664 101.021L116.731 100.071Z"
                  fill="#EBEBEB"
                />
                <path
                  d="M113.664 101.252C113.62 101.252 113.577 101.239 113.539 101.216C113.502 101.192 113.472 101.158 113.453 101.118L111.672 97.2492C111.651 97.2037 111.645 97.1529 111.655 97.1039C111.664 97.0549 111.689 97.01 111.725 96.9756C111.763 96.943 111.81 96.9232 111.86 96.9189C111.91 96.9146 111.96 96.926 112.003 96.9516L116.851 99.87C116.89 99.8934 116.922 99.9276 116.942 99.9684C116.963 100.009 116.971 100.055 116.967 100.1C116.96 100.145 116.942 100.186 116.913 100.22C116.884 100.254 116.846 100.279 116.803 100.292L113.731 101.252H113.664ZM112.411 97.7388L113.789 100.739L116.189 100.004L112.411 97.7388Z"
                  fill="#393939"
                />
                <path
                  d="M106.08 108.481C106.087 108.612 106.068 108.742 106.023 108.865C105.978 108.987 105.908 109.099 105.818 109.194C105.728 109.289 105.62 109.365 105.5 109.416C105.38 109.468 105.251 109.494 105.12 109.494C104.846 109.489 104.584 109.383 104.383 109.196C104.183 109.009 104.059 108.754 104.035 108.481C104.023 108.349 104.039 108.216 104.082 108.091C104.125 107.966 104.194 107.851 104.285 107.755C104.376 107.659 104.486 107.583 104.609 107.533C104.731 107.482 104.863 107.459 104.995 107.463C105.27 107.47 105.532 107.577 105.733 107.765C105.933 107.952 106.057 108.208 106.08 108.481Z"
                  fill="#393939"
                />
                <path
                  d="M112.657 108.48C112.668 108.612 112.652 108.744 112.609 108.869C112.565 108.994 112.496 109.107 112.405 109.203C112.314 109.299 112.204 109.374 112.082 109.424C111.96 109.474 111.829 109.498 111.697 109.493C111.422 109.488 111.159 109.382 110.958 109.196C110.757 109.009 110.632 108.754 110.607 108.48C110.599 108.35 110.618 108.219 110.663 108.095C110.708 107.972 110.777 107.859 110.867 107.764C110.957 107.669 111.066 107.593 111.186 107.541C111.306 107.489 111.436 107.463 111.567 107.463C111.843 107.467 112.107 107.573 112.309 107.761C112.51 107.949 112.634 108.206 112.657 108.48Z"
                  fill="#393939"
                />
                <path
                  d="M114.519 115.076C114.46 115.075 114.404 115.052 114.362 115.012C114.319 114.972 114.293 114.918 114.288 114.86C114.168 113.223 111.605 111.893 108.576 111.893C106.565 111.893 104.76 112.493 103.867 113.453C103.684 113.63 103.54 113.844 103.446 114.081C103.352 114.318 103.309 114.572 103.32 114.826C103.322 114.858 103.318 114.889 103.308 114.919C103.298 114.949 103.282 114.977 103.262 115.001C103.22 115.049 103.161 115.078 103.097 115.083C103.033 115.087 102.971 115.066 102.922 115.025C102.874 114.983 102.845 114.923 102.84 114.86C102.826 114.542 102.878 114.224 102.994 113.927C103.11 113.63 103.286 113.361 103.512 113.137C104.472 112.085 106.426 111.428 108.562 111.428C111.888 111.428 114.6 112.921 114.735 114.826C114.737 114.856 114.732 114.887 114.723 114.915C114.713 114.944 114.698 114.971 114.677 114.993C114.657 115.016 114.633 115.035 114.606 115.048C114.578 115.061 114.549 115.069 114.519 115.071V115.076Z"
                  fill="#393939"
                />
                <path
                  d="M102.322 106.426C102.264 106.425 102.208 106.403 102.164 106.363C102.12 106.319 102.096 106.26 102.096 106.198C102.096 106.136 102.12 106.076 102.164 106.032L103.186 104.933C103.23 104.891 103.289 104.867 103.349 104.867C103.41 104.867 103.469 104.891 103.513 104.933C103.534 104.954 103.551 104.98 103.563 105.008C103.574 105.036 103.58 105.066 103.58 105.096C103.58 105.127 103.574 105.157 103.563 105.185C103.551 105.213 103.534 105.238 103.513 105.259L102.49 106.359C102.468 106.381 102.442 106.398 102.413 106.409C102.384 106.421 102.353 106.427 102.322 106.426Z"
                  fill="#393939"
                />
                <path
                  d="M114.037 106.426C113.979 106.423 113.923 106.401 113.879 106.363L112.703 105.264C112.681 105.243 112.663 105.217 112.651 105.189C112.639 105.16 112.633 105.13 112.633 105.099C112.633 105.068 112.639 105.037 112.651 105.009C112.663 104.98 112.681 104.955 112.703 104.933C112.747 104.891 112.805 104.867 112.866 104.867C112.927 104.867 112.986 104.891 113.029 104.933L114.205 106.032C114.227 106.054 114.244 106.079 114.256 106.107C114.267 106.135 114.273 106.165 114.273 106.195C114.273 106.226 114.267 106.256 114.256 106.284C114.244 106.312 114.227 106.337 114.205 106.359C114.16 106.401 114.1 106.425 114.037 106.426Z"
                  fill="#393939"
                />
                <path
                  d="M97.084 127.271H98.1688L99.7336 129.355L99.5848 127.271H100.679L100.948 131.035H99.8392L98.284 128.966L98.4328 131.035H97.3384L97.084 127.271Z"
                  fill="#393939"
                />
                <path
                  d="M101.439 129.153C101.402 128.898 101.419 128.637 101.491 128.389C101.562 128.141 101.685 127.91 101.852 127.713C102.034 127.534 102.252 127.395 102.492 127.307C102.732 127.218 102.988 127.182 103.244 127.2C103.784 127.17 104.316 127.351 104.727 127.704C105.103 128.079 105.321 128.584 105.336 129.115C105.376 129.481 105.327 129.852 105.192 130.195C105.068 130.471 104.86 130.701 104.597 130.853C104.282 131.022 103.927 131.103 103.57 131.088C103.203 131.099 102.837 131.031 102.5 130.886C102.204 130.744 101.954 130.521 101.78 130.243C101.574 129.915 101.456 129.54 101.439 129.153ZM102.605 129.153C102.601 129.448 102.695 129.735 102.874 129.969C102.949 130.052 103.041 130.117 103.144 130.16C103.247 130.203 103.358 130.223 103.469 130.219C103.576 130.226 103.682 130.208 103.78 130.165C103.878 130.123 103.964 130.057 104.031 129.974C104.169 129.712 104.214 129.411 104.16 129.12C104.162 128.837 104.068 128.563 103.892 128.342C103.815 128.261 103.721 128.197 103.618 128.155C103.515 128.113 103.403 128.093 103.292 128.097C103.187 128.093 103.083 128.113 102.988 128.156C102.893 128.2 102.809 128.265 102.744 128.347C102.604 128.594 102.555 128.883 102.605 129.163V129.153Z"
                  fill="#393939"
                />
                <path
                  d="M107.592 127.273H109.32C109.605 127.264 109.888 127.311 110.155 127.412C110.366 127.5 110.553 127.637 110.702 127.81C110.853 127.986 110.969 128.19 111.043 128.41C111.121 128.647 111.169 128.892 111.187 129.14C111.224 129.453 111.199 129.771 111.115 130.076C111.049 130.287 110.932 130.478 110.774 130.633C110.643 130.772 110.477 130.874 110.294 130.93C110.071 130.995 109.84 131.03 109.608 131.036H107.885L107.592 127.273ZM108.816 128.127L108.965 130.181H109.248C109.423 130.193 109.598 130.165 109.761 130.1C109.869 130.038 109.948 129.936 109.982 129.817C110.037 129.604 110.05 129.382 110.021 129.164C110.03 128.871 109.94 128.584 109.766 128.348C109.677 128.267 109.572 128.206 109.458 128.168C109.344 128.13 109.223 128.116 109.104 128.127H108.816Z"
                  fill="#393939"
                />
                <path
                  d="M113.977 130.411H112.657L112.518 131.035H111.332L112.474 127.271H113.761L115.446 131.035H114.226L113.977 130.411ZM113.674 129.599L113.166 128.246L112.849 129.599H113.674Z"
                  fill="#393939"
                />
                <path
                  d="M114.898 127.271H118.431L118.498 128.203H117.313L117.514 131.035H116.353L116.151 128.203H114.966L114.898 127.271Z"
                  fill="#393939"
                />
                <path
                  d="M121.137 130.411H119.817L119.678 131.035H118.492L119.635 127.271H120.902L122.582 131.035H121.367L121.137 130.411ZM120.835 129.599L120.321 128.246L119.999 129.599H120.835Z"
                  fill="#393939"
                />
              </svg>
              <div className="noitemlbillingbox">
                You haven't placed any orders.
              </div>
            </div>
          )}
        </>
      )}
       <Modal
        aria-labelledby="transition-modal-title"
        aria-describedby="transition-modal-description"
        open={open}
        onClose={() => setOpen(false)}
        closeAfterTransition
        slots={{ backdrop: Backdrop }}
        slotProps={{
          backdrop: {
            timeout: 500,
          },
        }}
      >
        <Fade in={open}>
          <Box sx={style2}>
          <div className="modaltext">Confirm Cancellation</div>
          <div className="modalsubtext">
            Are you sure you want to cancel this subscription?
          </div>
           <div
            style={{
              display: "flex",
              justifyContent: "flex-end",
              gap: "10px",
              width: "100%",
            }}
          >
            <div
              className="cancelbuttonmodal"
              onClick={() => {
                setOpen(false);
              }}
            >
              Cancel
            </div>
            <div
              className="continuebuttonmodal"
              onClick={() => {
                cancelSubscription()
              }}
            >
              Continue
            </div>
          </div>
          </Box>
        </Fade>
      </Modal>
    </div>
  );
};

export default Billing;
